<template>
  <div>
    <hr-co-input
      v-bind="$attrs"
      :type="getType()"
      :auto-validation="!(modelValue.type === 'EMAIL')"
      :value="state.field.value"
      :label="state.field.label"
      :placeholder="state.field.help?.placeholder"
      :required="state.field.validation.required"
      :invalid="state.field.isInvalid"
      :max="getMax()"
      :helper="state.field.help?.hint"
      :errorMessage="state.field.fieldError"
      :masked="state.masked"
      data-test-id="hr-input-field"
      @blur="updateValue"
      @focus="focus"
      @input="changeInput"
    >
      <template v-slot:invalid class="HRField__invalid">{{
        state.field.fieldError
      }}</template>
    </hr-co-input>
  </div>
</template>

<script>
import { reactive } from 'vue';
import HrCoInput from '@/components/hr-co-input.vue';
import { validate } from '@/core/validation/validation';
import { enableMask } from '@/core/fields-to-mask.js';
import { WORK_RIGHTS_AU_FIELDS } from '@/core/field-names';
export default {
  name: 'hr-input-field',
  components: {
    HrCoInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value', 'focus'],
  setup(props, { emit }) {
    const MAX_TFN_LIMIT = 9;
    const MAX_PASSPORT_NUMBER_LIMIT = 20;
    const state = reactive({
      field: props.modelValue,
      masked: enableMask(props.modelValue),
    });

    function updateValue(value, obj) {
      state.field.value = typeof value === 'undefined' ? null : value;
      state.field.valueObj = obj;
      state.field.fieldError = '';

      validateField();
      emit('update:model-value', state.field);
    }

    function focus(value) {
      emit('focus', value);
    }

    function changeInput() {
      state.field.isInvalid = null;
    }

    function validateField() {
      validate(state.field);
    }

    function getType() {
      if (state.field.type === 'TFN_AU') {
        return 'tfnAu';
      }

      return 'text';
    }

    function getMax() {
      if (state.field.type === 'TFN_AU') {
        return MAX_TFN_LIMIT;
      } else if (state.field.name === WORK_RIGHTS_AU_FIELDS.PASSPORT_NUMBER) {
        return MAX_PASSPORT_NUMBER_LIMIT;
      }
      return null;
    }

    return {
      state,
      changeInput,
      focus,
      updateValue,
      getType,
      getMax,
    };
  },
};
</script>
